import * as c from 'common/constants';

/**
 * Is fetching reducer
 */
const initialFetchingState = {};

export const isFetching = (state = initialFetchingState, action) => {
  if (action.type === c.IS_FETCHING) {
    if (action.state) {
      return {
        ...state,
        [action.id || 'global']: action.state,
      };
    }
    const { [action.id]: omit, ...other } = state;

    return other;
  }

  return state;
};

export default isFetching;



// WEBPACK FOOTER //
// ./src/common/reducers/isFetchingReducer.js